import { render, staticRenderFns } from "./IdentifyDefaultViewer.vue.js?vue&type=template&id=d63650d8&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyDefaultViewer.vue?vue&type=template&id=d63650d8&scoped=true"
import script from "./IdentifyDefaultViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyDefaultViewer.vue?vue&type=script&lang=js"
export * from "./IdentifyDefaultViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyDefaultViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63650d8",
  null
  
)

export default component.exports